import { makeStyles } from "tss-react/mui";

export const applicationPageStyles = makeStyles()({
  mainBlock: {
    background: "#fff",
    height: "calc(100vh - 80x)",
    flexWrap: "nowrap",
    overflowY: "hidden",
    paddingBottom: '0',
    borderRadius: "12px",
    "&::-webkit-scrollbar": {
      width: "4px !important",
      height: "5px !important",
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      maxHeight: "5px !important",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#3B78CE",
      outline: "1px solid slategrey",
    },
    "&::-webkit-scrollbar-button": {
      maxHeight: "5px"
    },
  },
  searchBar: {
    width: "283px",
    height: "45px",
    borderRadius: "5px",
    display: "flex",
    justifyContent: "center",
    backgroundColor: "#F3F5F9",
    "& .MuiOutlinedInput-notchedOutline": {
      borderWidth: "0px !important",
    },
    "& .MuiInputBase-input": {
      fontSize: "13px",
      fontWeight: "600",
      color: "#141414",
    },
    "& .MuiOutlinedInput-root": {
      paddingLeft: "20px",
    },
    "& .MuiInputAdornment-root": {
      marginRight: "10px",
    },
  },
  footer: {
    position: "absolute",
    bottom: 0,
    zIndex: 1,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#3B78CE",
    padding: "16px 50px",
  },
  siteMap: {
    display: "inline-flex",
    listStyle: "none",
    padding: "0 10px",
  },
  CopyRightText: {
    color: "#FFFFFF",
    fontSize: "13px",
    fontWeight: "600",
    lineHeight: "18px",
  },
  site: {
    padding: "0px 20px",
    borderRight: "1px solid white",
    "@media screen and (max-width:899px)": {
      padding: "0px 20px 0px 0px !important",
    },
  },
  icon: {
    fontSize: "medium !important",
  },
  heading: {
    fontSize: "15px",
    color: "#000",
    fontWeight: "600",
  },
  placeholder: {
    fontWeight: "600 !important",
    fontSize: "15px !important",
    color: "#7A7B7E !important",
  },
  tableCtn:{
    width: "100%",
    marginTop: "10px",
    height: 'calc(100% - 15px)',
  }
});